import axios from 'axios';
import {apiUrl} from "../../constants/config";

export default {
    state: {

    },
    getters: {

    },
    mutations: {

    },
    actions: {
        getOrganizations({}) {
            return new Promise((resolve, reject) => {
                axios.get(apiUrl + 'api/organization').then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        getOrgById({}, id) {
            return new Promise((resolve, reject) => {
                axios.get(apiUrl + 'api/organization/' + id).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        }
    }
}
